"use client"
import { useEffect } from "react"

interface SVGTextFitterProps {
  children?: React.ReactNode
}

export function SVGTextFitter({ children }: SVGTextFitterProps) {
  useEffect(() => {
    const fitSVGText = () => {
      const svgElements = document.querySelectorAll("svg")

      svgElements.forEach((element) => {
        const textElement = element.querySelector("text")
        if (textElement) {
          try {
            const bbox = textElement.getBBox()
            element.setAttribute(
              "viewBox",
              [bbox.x, bbox.y, bbox.width, bbox.height].join(" "),
            )
          } catch (error) {
            console.warn(
              "Failed to get bounding box for SVG text element:",
              error,
            )
          }
        }
      })
    }

    // Run on mount
    fitSVGText()

    // Run on window resize
    window.addEventListener("resize", fitSVGText)

    // Cleanup
    return () => {
      window.removeEventListener("resize", fitSVGText)
    }
  }, [])

  return <>{children}</>
}
